import { Text, View } from '@react-pdf/renderer'
import React, { useEffect, useState } from 'react'
import { getFirstPartyData, getSecondPartyData } from './Data';

const SignaturesTbl = ({contractDetails}) => {

  const [firstParty,setFirstParty] = useState([]);
  const [secondParty,setSecondParty] = useState([]);

  useEffect(() => {
    if(contractDetails){
      const _firstParty = getFirstPartyData(contractDetails)
      setFirstParty(_firstParty)

      const _secondParty = getSecondPartyData(contractDetails);
      setSecondParty(_secondParty)
    }
  }, [contractDetails]);


  return (
    <>
      <Text
        style={{ fontFamily: "Helvetica-Bold", fontSize: 14, marginTop: 20 }}
      >
        SIGNATURES
      </Text>
      <View
        style={{
          flexDirection: "row",
          padding: 2,
          backgroundColor: "black",
        }}
        break
      >
        <View style={{ width: "100%" }}>
          <Text style={{ textAlign: "center", color: "white" }}>
            FIRST PARTY
          </Text>
        </View>
        <View style={{ width: "100%" }}>
          <Text style={{ textAlign: "center", color: "white" }}>
            SECOND PARTY
          </Text>
        </View>
      </View>
      <View style={{ flexDirection: "row", border: 1, gap: 2 }}>
        <View style={{ width: "100%", padding: 2 }}>
          {firstParty?.map((item, index) => (
            <View key={index} style={{ marginVertical: 10 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "Helvetica-Bold",
                  textTransform: "uppercase",
                }}
              >
                {item.title}
              </Text>
              <Text style={{ textTransform: "uppercase" }}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>Name:</Text>{" "}
                {item.name}
              </Text>
              <Text style={{ textTransform: "uppercase" }}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>
                  Designation:
                </Text>
                {item.designation}
              </Text>
              <View style={{ height: 65 }}>
                <Text style={{ textTransform: "uppercase" }}>
                  <Text style={{ fontFamily: "Helvetica-Bold" }}>
                    Signature:
                  </Text>
                  {item.signature}
                </Text>
              </View>
            </View>
          ))}
          <View style={{ height: 65 }}>
            <Text
              style={{
                textTransform: "uppercase",
                fontFamily: "Helvetica-Bold",
              }}
            >
              Stamp:
            </Text>
          </View>
          <View style={{ height: 65 }}>
            <Text
              style={{
                textTransform: "uppercase",
                fontFamily: "Helvetica-Bold",
              }}
            >
              Date:
            </Text>
          </View>
        </View>
        <View style={{ width: "100%", padding: 2 }}>
          {secondParty?.map((item, index) => (
            <View key={index} style={{ marginVertical: 10 }}>
              <Text
                style={{
                  fontSize: 10,
                  fontFamily: "Helvetica-Bold",
                  textTransform: "uppercase",
                }}
              >
                {item.title}
              </Text>
              <Text style={{ textTransform: "uppercase" }}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>Name:</Text>{" "}
                {item.name}
              </Text>
              <Text style={{ textTransform: "uppercase" }}>
                <Text style={{ fontFamily: "Helvetica-Bold" }}>
                  Designation:
                </Text>
                {item.designation}
              </Text>
              <View style={{ height: 65 }}>
                <Text style={{ textTransform: "uppercase" }}>
                  <Text style={{ fontFamily: "Helvetica-Bold" }}>
                    Signature:
                  </Text>
                  {item.signature}
                </Text>
              </View>
            </View>
          ))}
          <View style={{ height: 65 }}>
            <Text
              style={{
                textTransform: "uppercase",
                fontFamily: "Helvetica-Bold",
              }}
            >
              Stamp:
            </Text>
          </View>
          <View style={{ height: 65 }}>
            <Text
              style={{
                textTransform: "uppercase",
                fontFamily: "Helvetica-Bold",
              }}
            >
              Date:
            </Text>
          </View>
        </View>
      </View>
    </>
  );
}

export default SignaturesTbl